import { css, cx } from "@emotion/css"

import { Legend } from "./Legend"

const styles = {
  root: css`
    display: flex;

    flex-wrap: wrap;
  `,
  directions: {
    row: css`
      flex-direction: row;
      align-items: center;
      .Legend {
        margin-block-end: var(--spacing-xxs, 4px);
      }
      .Legend:not(:last-child) {
        margin-inline-end: var(--spacing-m, 16px);
      }
    `,
    column: css`
      flex-direction: column;
      .Legend:not(:last-child) {
        margin-block-end: var(--spacing-xs, 8px);
      }
    `,
  },
}

type LegendsProps = {
  keys: string[]
  getColor: (key: string, idx: number) => string
  getLabel?: (key: string, idx: number) => string
  className?: string
  direction?: "row" | "column"
}

export function Legends(props: LegendsProps) {
  const { keys, getColor, getLabel, className, direction = "row" } = props
  return (
    <div className={cx(styles.root, styles.directions[direction], className)}>
      {keys.map((key, idx) => {
        const color = getColor(key, idx)
        const label = getLabel?.(key, idx) ?? key
        return <Legend key={key} label={label} color={color} />
      })}
    </div>
  )
}
